import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import { Event } from '@ifeng/ui_base';
import Ad, { handleAd } from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import Tabs from './tabs';
import TabPane from './tabPane';
import ContentList from './contentList';
import Live from './live';

class Info extends React.Component {
    static propTypes = {
        content: PropTypes.object,
        headline: PropTypes.array,
    };

    state = {
        insertArr: [],
        replaceArr: [],
        adFn: null,
        activeIndex: 0,
        selected: true,
    };

    event = new Event();

    insert = (insertArr, replaceArr, adFn) => {
        if (adFn && typeof adFn === 'function') {
            this.setState({
                insertArr,
                replaceArr,
                adFn,
                activeIndex: this.activeIndex,
            });
        }

        return;
    };

    adInit = async (index, len) => {
        this.activeIndex = index;

        if (!(this.event.events && this.event.events.init)) {
            try {
                const { infoAd } = this.props.content;
                const callback = await handleAd(infoAd);

                callback(infoAd.data, this.event, this.insert);
            } catch (e) {
                console.error(e);
            }
        }

        try {
            this.event.trigger('init', { index, len });
        } catch (e) {
            console.error(e);
        }
    };

    handleSelected = () => {
        const { selected } = this.state;

        this.setState({ selected: !selected });
    };

    /**
     * 渲染组件
     */
    render() {
        const { insertArr, replaceArr, adFn, activeIndex, selected } = this.state;
        const {
            content: { infoTitle, hardAd, liveLogo },
            headline,
        } = this.props;

        return (
            <div className={styles.info}>
                <Tabs>
                    {infoTitle.map((item, index) => (
                        <TabPane key={index} tab={item.title}>
                            <div style={{ display: index === infoTitle.length - 1 ? 'block' : 'none' }}>
                                <Live
                                    content={liveLogo}
                                    current={index === infoTitle.length - 1}
                                    selected={selected}
                                    handleSelected={this.handleSelected}
                                    moreUrl={item.url}
                                />
                            </div>
                            <div style={{ display: index !== infoTitle.length - 1 ? 'block' : 'none' }}>
                                <ContentList
                                    headline={headline}
                                    index={index}
                                    activeIndex={activeIndex}
                                    dataKey={item.key}
                                    moreUrl={item.url}
                                    event={this.event}
                                    adInit={this.adInit}
                                    insertArr={insertArr}
                                    replaceArr={replaceArr}
                                    adFn={adFn}
                                />
                            </div>
                        </TabPane>
                    ))}
                </Tabs>
                <NoSSR onSSR={<div className={styles.hardAd} />}>
                    <Ad content={hardAd} styleName={styles.hardAd} />
                </NoSSR>
            </div>
        );
    }
}

export default errorBoundary(Info);
